import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const IMAGE_WIDTH = 104;
const IMAGE_HEIGHT = 132;

const style = () => {
  const {
    borderWidth2,
    colorBorderInput,
    borderRadius3,
    space4,
    space1,
    space2,
    colorBorderInputFocus,
    colorText,
    colorBgRose,
    colorTextMedium,
    colorTextMediumLight,
  } = theme();

  return StyleSheet.create({
    activeBorder: {
      borderColor: colorBorderInputFocus,
    },
    brand: {
      color: colorTextMedium,
    },
    brandMissing: {
      color: colorTextMedium,
    },
    buttonItem: {
      padding: 0,
    },
    buttonsList: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    checkbox: {
      alignItems: "stretch",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      marginRight: space4,
    },
    container: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
    },
    disabled: {
      opacity: 0.26,
    },
    icon: {
      color: colorText,
    },
    labelWrapper: {
      alignItems: "flex-start",
      display: "flex",
      flexGrow: 1,
      justifyContent: "center",
    },
    price: {
      color: colorText,
    },
    priceMissing: {
      color: colorTextMedium,
    },
    priceStrikethrough: {
      color: colorTextMedium,
      marginLeft: 8,
      textDecorationLine: "line-through",
    },
    priceStrikethroughMissing: {
      color: colorTextMediumLight,
      marginLeft: 8,
      textDecorationLine: "line-through",
    },
    priceWrapper: {
      display: "flex",
      flexDirection: "row",
    },
    productDetail: {
      display: "flex",
      flexDirection: "row",
    },
    productInfo: {
      display: "flex",
      flexDirection: "column",
      flex: 3,
      justifyContent: "space-between",
      paddingBottom: space1,
      paddingLeft: space2,
    },
    productVariantInfo: {
      paddingRight: space4,
    },
    thumbnail: {
      height: IMAGE_HEIGHT,
      width: IMAGE_WIDTH,
    },
    thumbnailWrapper: {
      borderColor: colorBorderInput,
      borderRadius: borderRadius3,
      borderWidth: borderWidth2,
      overflow: "hidden",
    },
    variant: {
      color: colorTextMedium,
    },
    wishlistedIcon: {
      color: colorBgRose,
    },
  });
};

export { style, IMAGE_WIDTH, IMAGE_HEIGHT };
